import { useEffect } from "react";
import { useLocalStorage } from "src/hook/useLocalStorage";
import { Auth } from "src/auth/auth";
import { useAuth } from "src/hook/useContext";

const CallBack = () => {
  const { user } = useAuth();
  const [token, setToken] = useLocalStorage("token", null);
  const [userUpt, setUserUpt] = useLocalStorage("user", user);

  const userAuth = async () => {
    const data = await Auth.currentSession();
    const dataUser = await Auth.currentAuthenticatedUser();
    await setToken(data?.idToken);
    await setUserUpt(JSON.stringify(dataUser));
    if (token && userUpt) {
        window.location.href = '/';
    }
  };

  useEffect(() => {
    userAuth();
  });

  return <></>;
};

export default CallBack;
